import request from '@/libs/request'
import { toast } from '@/libs/utils'
// 获取检查单列表
export async function getCheckOrderList (params) {
  let data = await request.post('/order/orderCheckOrderInfo/findCheckOrderByopenId', params, false, '加载中...', false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取检查订单列表失败！'})
    return {results: []}
  }
}
// 查询检查单详情
export async function getCheckOrderDetail (params) {
  let data = await request.post('/order/orderCheckOrderInfo/getMyOrderCheckOrderDetail', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取检查订单详情失败！'})
  }
}
// 查询报告列表
export async function getCheckReportLists (params) {
  let data = await request.post(`/doctor/queryOrderCheckReportList`, params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取报告列表异常'})
  }
}
// 查询报告列表
export async function getCheckReportList (params) {
  let data = await request.post('/order/orderCheckReport/getMyReportList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取报告列表失败！'})
  }
}
// 获取评价项目
export async function getEvaluationItem (params) {
  let data = await request.post('/bdc/commonParams/getByCode', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取评价项目失败！')
}
// 提交影像评价
export async function subEvaluation (params) {
  let data = await request.postJson('/uac/userRate/add', params, false, '加载中...', false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  }
  throw Error(data.message || '提交影像评价失败！')
}
// 查询报告详情
export async function getReportDetail (params, showLoading = false) {
  let data = await request.post('/order/orderCheckReport/getById', params, showLoading)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '查询报告详情失败！'})
  }
}
// 电子影像支付
export async function imagePay (params) {
  let data = await request.post('/order/wechat/pay/buyElectronImages', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data || null
  } else {
    toast({msg: data.message || '支付电子影像失败！'}) 
  }
}
// 获取影像中心信息
export async function getImageCenterMsg (params) {
  let data = await request.get('/bdc/commonMedicalImageCenter/findById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result || null
  } else {
    toast({msg: data.message || '获取影像中心信息失败！'})
  }
}
// 问卷校验
export async function checkSurveyCode (params) {
  let data = await request.post('/uac/userRate/nextStep', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error( data.message || '问卷校验失败！')
}